<template lang="pug">
  el-dialog(
    width="75%"
    top="5vh"
    :modal-append-to-body="false"
    :visible.sync="visible"
    :close-on-click-modal="false"
    @close="close"
  )
    quiz(v-if="type == 'answerinput' || type == 'coding' " :type="type")
    library-selector(v-else-if="type == 'library'" :type="type")
</template>

<script>
import Quiz from "@/components/demo/questions/Quiz";
import LibrarySelector from "@/components/demo/library/LibrarySelector";

export default {
  name: "DemoModal",

  components: {
    Quiz,
    LibrarySelector
  },

  props: {
    visibleProp: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      required: true
    }
  },

  computed: {
    visible: {
      get() {
        return this.visibleProp;
      },

      set(value) {
        if (value === false) {
          this.$emit("close");
        }
      }
    }
  },

  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
